<template>
  <div>
    <div class="map-overlay" v-show="MapOverlay"></div>
    <nav id="sidebar" class="sidebar-wrapper">
      <div class="nav-overlay" v-show="NavOverlay"></div>
      <div class="sidebar-vuebar" v-bar>
        <div class="sidebar-content">
          <div
            class="sidebar-brand"
            v-on:mouseenter="showPlayerBtn"
            v-on:mouseleave="showPlayer = false, NavOverlay = false, MapOverlay = false"
          >
            <a href="#">{{ $t('app.name') }}</a>
            <img class="sidebar-brand-img" src="img/invest_park_logo.png" />
            <img class="sidebar-brand-img" src="img/psi_logo.png" />
            <div v-show="showPlayer" class="sidebar-play" @click="$modal.show('modal-player');">
              <i class="fas fa-play"></i>
            </div>
          </div>

          <transition name="fade">
            <template v-if="showDetails">
              <OfferDetails v-if="$store.getters.currentTeren || $store.getters.currentInwestor" />
              <HallDetails v-else-if="$store.getters.currentHala" />
              <OfficeDetails v-else-if="$store.getters.currentBiuro" />
              <NotFound v-else-if="['tereny', 'hale', 'biura', 'inwestorzy'].includes($store.getters.listType)"/>
              <LoadingDetails v-else />
            </template>
          </transition>

          <transition name="fade">
            <div v-show="showMenu">
              <Tree />
              <div class="sidebar-search">
                <div class="sidebar-search-panel">
                  <div class="sidebar-search-title">
                    <i class="fas fa-search"></i>
                    <span>{{ $t("nav.searchPanel") }}</span>
                  </div>
                </div>
                <div class="sidebar-search-image">
                  <img src="img/search_image.jpg" />
                </div>
                <div class="sidebar-search-body">
                  <span>{{ $t("nav.searchLabel") }}</span>
                  <p>{{ $t("nav.searchText") }}</p>

                  <button @click="$modal.show('modal-search');">
                    <i class="fas fa-search"></i>
                    {{ $t("nav.searchGo") }}
                  </button>

                  <b-button
                    href="https://invest-park.com.pl/dla-inwestora/ulgi-podatkowe-pomoc-publiczna/"
                    target="_blank"
                  >{{ $t("nav.support") }}</b-button>
                </div>
              </div>
              <div class="sidebar-contact-modal">
                <div class="sidebar-contact">
                  <a @click="$modal.show('doi-modal')">
                    <div class="sidebar-contact-btn">
                      <i class="fas fa-user"></i>
                    </div>
                    <div class="sidebar-contact-text">{{ $t("nav.doi") }}</div>
                  </a>
                </div>
              </div>
              <div class="sidebar-lang">
                <a @click="switchLang('pl');">PL</a> /
                <a @click="switchLang('en');">EN</a> /
                <a @click="switchLang('de');">DE</a>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <div class="sidebar-footer" :class="{wide: isPhoneLayout}">
        <div id="close-sidebar" @click="togglNav()">
          <span class="close-sidebar-text" v-if="isPhoneLayout">{{$t("nav.gotomap")}}</span>
          <i class="fas fa-angle-left"></i>
        </div>
        <a id="show-sidebar" @click="togglNav();" class="btn btn-sm">
          <i class="fas fa-angle-right"></i>
        </a>
      </div>

      <SearchModal />

      <DoiModal :currlang="currlang" />
      <InfrastructureDetailsModal :currlang="currlang" />
      <PlayerModal />
      <CalculatorModal />
      <QRCodeModal />
    </nav>
    <div ref="lightboxGallery"></div>
  </div>
</template>

<script>
import { toHash, updateFromHash } from "../path";
import { openLightGallery } from "../lightboxGallery"

import CartogramPanelMixin from "@/mixins/CartogramPanelMixin";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON.js";

import OfferDetails from "./nav/details/OfferDetails";
import HallDetails from "./nav/details/HallDetails";
import OfficeDetails from "./nav/details/OfficeDetails";
import LoadingDetails from "./nav/details/LoadingDetails";
import Tree from "./nav/Tree";
import NotFound from "./nav/details/NotFound";

import InfrastructureDetailsModal from "./modals/InfrastructureDetailsModal";
import SearchModal from "./modals/SearchModal";
import DoiModal from "./modals/DoiModal";
import PlayerModal from "./modals/PlayerModal";
import CalculatorModal from "./modals/CalculatorModal";
import QRCodeModal from "./modals/QRCodeModal";
import IsPhoneLayoutMixin from "./IsPhoneLayoutMixin";

export default {
  mixins: [CartogramPanelMixin, IsPhoneLayoutMixin],
  computed: {
    ibcShow() {
      return this.status == "zainwest";
    },
    API_URL: function() {
      return process.env.VUE_APP_API_URL;
    },

    nav() {
      return this.$store.getters.nav;
    },
    showMenu() {
      return this.$store.getters.navType == "list";
    },
    showDetails() {
      return this.$store.getters.navType == "details";
    },
    currentOferta() {
      return this.$store.getters.currentOferta;
    },

    investmentAreasArrayFiltered() {
      return this.investmentAreasArray;
    }
  },
  data() {
    return {
      shouldUpdate: true,
      map: undefined,
      showModalCalc: false,
      currlang: "pl",
      gminyLoaded: false,
      investmentAreasArray: [],
      investmentAreasArrayS: [],
      showInfo: false,
      showInfoHalls: false,
      showInfoOffices: false,
      showPlayer: false,
      MapOverlay: false,
      NavOverlay: false,
      isActive: true,
      community: "",
      district: "",
      districtID: "",
      districtName: "",
      status: "",
      districtArray: [],
      communityArray: [],

      ficzerySource: new VectorSource({
        format: new GeoJSON({ featureProjection: "EPSG:3857" })
      }),
      ficzerySourceCache: undefined,
      ficzeryLayer: new VectorLayer({
        source: this.ficzerySource,
        visible: true
      })
    };
  },
  ready() {
    this.createMap();
  },
  methods: {
    openModalCalc() {
      this.showModalCalc = true;
    },
    // Nav
    showPlayerBtn() {
      this.MapOverlay = !this.MapOverlay;
      this.NavOverlay = !this.NavOverlay;
      this.showPlayer = !this.showPlayer;
    },
    switchLang(lang) {
      this.$i18n.i18next.changeLanguage(lang);
      this.currlang = lang;
      this.$root.$emit("currlang", this.currlang);
    },
    togglNav() {
      this.isActive = !this.isActive;
      this.$root.$emit("toggle", this.isActive);
    },

    // LoadingDetails
    openLightbox(zdjecia, index) {
      zdjecia = zdjecia || [];
      let dynamicElements;
      if (zdjecia.length === 0) {
        dynamicElements = [{
          src: "img/invest_park_logo_big.png",
          thumb: "img/invest_park_logo_big.png",
        }];

      } else {
        dynamicElements = zdjecia.map(img => ({
          src: this.imgToBigSrc(img),
          thumb: this.imgToSrc(img),
        }));
      }
      let el = this.$refs.lightboxGallery;
      // https://stackoverflow.com/a/5660165
      let handler;
      handler = function() {
        window.lgData[el.getAttribute('lg-uid')].destroy(true);
        el.removeEventListener('onCloseAfter', handler, false);
      };
      el.addEventListener('onCloseAfter', handler, false);
      openLightGallery(el, dynamicElements, index);
    },

    // Nav
    groupBy(array, key) {
      const result = {};
      array.forEach(item => {
        if (!result[item.properties[key]]) {
          result[item.properties[key]] = [];
        }
        result[item.properties[key]].push(item);
      });
      return result;
    },
    setValues(community, investAreaIndex) {
      this.setCurrentOferta(community.data[investAreaIndex]);
    },
    updatePermalink(move = false) {
      if (!this.shouldUpdate) {
        return;
      }
      let view = this.map.getView();

      let nav = this.nav;
      let hash = toHash({ nav, view: move && view });
      let state = {
        zoom: view.getZoom(),
        center: view.getCenter(),
        rotation: view.getRotation()
      };
      if (move) {
        window.history.replaceState(state, "map", hash);
      } else {
        window.history.pushState(state, "map", hash);
      }
    },
    updateStateFromHash() {
      updateFromHash({
        hash: window.location.hash,
        view: this.map.getView(),
        store: this.$store
      });
    },
    setPermaLink() {
      this.shouldUpdate = false;
      this.updateStateFromHash();
      this.shouldUpdate = true;
    },

    setCurrentOferta(oferta) {
      if (oferta.properties.status == "zainwest") {
        this.$store.dispatch("showDetails", {
          listType: "inwestorzy",
          item: oferta
        });
      } else {
        this.$store.dispatch("showDetails", {
          listType: "tereny",
          item: oferta
        });
      }
    },

    imgToSrc(filename) {
      return `${this.API_URL}/pliki/get/400px/${filename}`;
    },
    imgToBigSrc(filename) {
      return `${this.API_URL}/pliki/get/1000px/${filename}`;
    }
  },
  components: {
    InfrastructureDetailsModal,
    OfferDetails,
    HallDetails,
    OfficeDetails,
    LoadingDetails,
    Tree,
    SearchModal,
    DoiModal,
    PlayerModal,
    CalculatorModal,
    QRCodeModal,
    NotFound
  },
  watch: {
    nav(nav) {
      if (nav && nav.isFromPath) {
        // watch from $store.commit does not seem to be instant
        return;
      }
      this.updatePermalink();
    }
  },
  mounted: function() {
    this.$store.dispatch("jst/download");

    this.$store.dispatch("tereny/download").then(response => {
      this.$root.$emit("ofertyReady", response.data);
    });
    this.$store.dispatch("hale/download").then(response => {
      this.$root.$emit("haleReady", response.data);
    });
    this.$store.dispatch("biura/download").then(response => {
      this.$root.$emit("biuraReady", response.data);
    });
    this.$store.dispatch("inwestorzy/download").then(response => {
      this.$root.$emit("ofertyZainwestReady", response.data);
    });

    this.$root.$on("mainMap", data => {
      this.map = data;
      this.map.addLayer(this.ficzeryLayer);
      this.setPermaLink();
      this.map.on("moveend", () => {
        this.updatePermalink(true);
      });
    });
    this.$root.$on("ficzerySourceCache", data => {
      this.ficzerySourceCache = data;
      this.ficzerySource.addFeatures(this.ficzerySourceCache);
    });

    this.$modal.show("modal-calc");
    this.$root.$on("gminyReady", () => {
      this.gminyLoaded = true;
    });
    this.$root.$on("gminyLoading", () => {
      this.gminyLoaded = false;
    });
    this.showModalCalc = false;

    window.onhashchange = event => {
      this.shouldUpdate = false;
      this.updateStateFromHash(event.newURL.split("#")[1]);
      this.shouldUpdate = true;
    };
  }
};
</script>

<style scoped>
.sidebar-wrapper
  .sidebar-details
  .sidebar-details-body
  .sidebar-details-techinf
  li {
  width: 60px;
  height: 60px;
}
</style>